import { render, staticRenderFns } from "./HotelSummary.vue?vue&type=template&id=037b3341&"
import script from "./HotelSummary.vue?vue&type=script&lang=js&"
export * from "./HotelSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037b3341')) {
      api.createRecord('037b3341', component.options)
    } else {
      api.reload('037b3341', component.options)
    }
    module.hot.accept("./HotelSummary.vue?vue&type=template&id=037b3341&", function () {
      api.rerender('037b3341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/DebtorsReport/HotelSummary.vue"
export default component.exports